"use client";

import React from "react";
import { Star, StarHalf, ShieldCheck } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CertifiedSecuritySince2010() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="185468" id="logik-i-siffror" className="bg-[#F7F8FA] section ![padding:40px_48px_80px_48px]">
      <div className="container mx-auto px-4 !h-[204px]">
        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Card className="text-card-foreground flex flex-col gap-6 rounded-xl py-6 card bg-transparent shadow-none transition-all duration-300 !h-[204px]">
            <CardContent className="p-6 flex flex-col items-center justify-center text-center gap-4 h-full">
              <div className="flex flex-col items-center gap-2">
                <h3 className="text-primary tracking-widest !font-black !text-7xl !font-mono ![padding:40px_0px_10px_0px]">4+</h3>
                <p className="label text-primary uppercase tracking-widest font-medium">ÅRS ERFREHET</p>
              </div>
              <Badge variant="secondary" className="mt-1 px-4 py-1.5 text-sm font-semibold shadow-none opacity-0">
                Auktoriserad VVS
              </Badge>
            </CardContent>
          </Card>

          <Card className="text-card-foreground flex flex-col gap-6 rounded-xl py-6 card bg-transparent shadow-none transition-all duration-300 !h-[204px]">
            <CardContent className="p-6 flex flex-col items-center justify-center text-center gap-4 h-full">
              <div className="flex flex-col items-center gap-2">
                <h3 className="font-mono text-primary tracking-widest !text-7xl !font-black ![padding-top:40px]">10+</h3>
                <p className="label text-primary uppercase tracking-widest font-medium">AKTIVA KUNDER</p>
              </div>
              <Badge variant="secondary" className="mt-1 px-4 py-1.5 text-sm font-semibold shadow-none opacity-0">
                Auktoriserad VVS
              </Badge>
            </CardContent>
          </Card>

          <Card className="text-card-foreground flex flex-col gap-6 rounded-xl py-6 card bg-transparent shadow-none transition-all duration-300 !h-[204px]">
            <CardContent className="p-6 flex flex-col items-center justify-center text-center gap-4 h-full">
              <div className="flex flex-col items-center gap-2">
                <h3 className="font-mono text-primary tracking-widest !font-black !text-7xl ![padding-top:40px]">100%</h3>
                <p className="label text-primary uppercase tracking-widest font-medium">
                  PERSONLIG SERVICE
                </p>
              </div>
              <Badge variant="secondary" className="mt-1 px-4 py-1.5 text-sm font-semibold shadow-none opacity-0">
                Auktoriserad VVS
              </Badge>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}